import React, { useState, useEffect } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { ListSubheader } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import {
  setState
} from "../analyzeSlice";
import customerGroupSetupSlice from "../../Setup/Customer/customerGroupSetupSlice";
import InfiniteScroll from "react-infinite-scroller";
import { stubFalse } from "lodash";
import {
  Backdrop,
  CircularProgress,
} from "@mui/material";

const MultiSelectCustomers = (props) => {
  const dispatch = useDispatch();
  const customerData = props?.customers;
  const customers = customerData?.map((item) => item.customerName);
  const [customerName, setCustomerName] = useState([]);
  const [displayItem, setDisplayItem] = React.useState(customerData.length - 1);
  const [searchText, setSearchText] = React.useState("");
  const [namesData, setNamesData] = React.useState([]);
  const textInput = React.useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const state = useSelector((store) => store.analyze);
  const itemsPerPage = 200;
  const [hasMore, setHasMore] = useState(true);
  const [records, setrecords] = useState(itemsPerPage);
  const [recordsName, setrecordsName] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const {
    selectedCustomers,
    clearDataValues,
  } = state;
 
  useEffect(() => {
    dispatch(setState("allCustomersSelected", false));
  }, [])
 
  const loadMore = () => {
    if (records === customerData.length) {
      setHasMore(false);
    } else {
      setTimeout(() => {
        setrecords(records + itemsPerPage);
      }, 2000);
    }
  };

  
  const handleChange = (e, name) => {  
    dispatch(setState("searchFilterText",""));
    let items = [...customerName];
 
    if (e.target.checked) items.push(name);
    else {
      var index = items.indexOf(name);
      items.splice(index, 1);
    }
 
    setCustomerName(items);
    let itemcount = items.length;
    setDisplayItem(itemcount);
    if (itemcount == 0) {
      setSelectAll(false);
      //dispatch(setState("allCustomersSelected", false));
    }
    if (itemcount == customers.length) {
      setSelectAll(true);
      //dispatch(setState("allCustomersSelected", true));
    }
    else {
      setSelectAll(false);
      //dispatch(setState("allCustomersSelected", false));
    }
  };
 
  useEffect(() => {
    // Clear search text value
    setNamesData(customers);
    if(customerData.length > 0){
    handleSelectAll();
    }
  }, [customerData]);

 

  const handleDelete = (e) => {
    e.preventDefault();
    setCustomerName([]);
    setSelectAll(false);
  };
  const handleInputChange = (value) => {
    setSearchText(value);
  };


 
  const handleSelectAll = () => {
    if(customers.length > 100){
      setIsLoading(true);
    }
    setSelectAll(!selectAll);
   const timer = setTimeout(()=>{
    const isselectAll = !selectAll;
    if (!selectAll) {
      if(searchText){
          let val = customers.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));
          let item = [...customerName, ...val];
          const distinctArray = [...new Set(item)];
          setCustomerName(distinctArray);
          let itemcount = distinctArray.length-1;
          setDisplayItem(itemcount);
      }else{
          setCustomerName(customers);
          let itemcount = customers.length-1;
          setDisplayItem(itemcount);
          //dispatch(setState("allCustomersSelected", true));
      }
  } else {
      if(searchText){
          let val = customers.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));
          let item = [...customerName];
          item = item.filter((name) => !val.includes(name));
          const distinctArray = [...new Set(item)];
          setCustomerName(distinctArray);
          let itemcount = distinctArray.length;
          setDisplayItem(itemcount);
      }else{
          setCustomerName([]);
          let itemcount = 0;
          setDisplayItem(itemcount);
      }
    }
 }, 10);
  return () => clearTimeout(timer);
  };
 
  console.log(customerName);
 
  useEffect(() => {
    let itemcount = selectedOptions.length - 1;
    setDisplayItem(itemcount);
  }, [selectedOptions])
 
  useEffect(() => {
    let itemcount = customerName.length - 1;
    setDisplayItem(itemcount);
  }, [customerName])
 

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchText) {
        setNamesData((prevVal) => {
          let val = customers.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));
 
          return val;
        });
      } else {
        setSearchText();
        setNamesData(customers);
      }
 
      setTimeout(() => {
        if (textInput.current) textInput.current.focus();
      }, 100);
    }, 500);
 
    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);
 
  const getCustomerIdsFromNames = (customerNames) => {
    const customerIds = customerNames.map((name) => {
      const customer = customerData.find((option) => option.customerName === name);
      return customer ? customer.customerID : null;
    });
    return customerIds.filter((id) => id !== null);
  };
 
  useEffect(() => {
    const timeout = setTimeout(()=>{
    dispatch(setState("customerList", customerName));
    if(customerName.length > 0){
      dispatch(setState("clearDataValues", false));
    }
    if(customerName.length === customers.length){
      dispatch(setState("allCustomersSelected", true));
    }else{
      dispatch(setState("allCustomersSelected", false));
    }
    setIsLoading(false)
    }, 500);
    return () => clearTimeout(timeout);
  }, [customerName])
 
  useEffect(() => {
if(customerData.length === 0){
  setCustomerName([]);
  setSelectAll(false);  
}

    if (clearDataValues) {
      setCustomerName([]);
      setSelectAll(false);
      setSearchText("");
    }
  }, [clearDataValues])
 
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress style={{ position: 'absolute', zIndex: 1300 }}/>
      </Backdrop>
        <InfiniteScroll
        pageStart={0}
        loadMore={loadMore}
        hasMore={hasMore}
        useWindow={false}
      >
      <FormControl>
        <InputLabel>Customer</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          //fullWidth
          sx={{
            width: "250px !important",
            height: "44px !important",
          }}
          MenuProps={{
            style: {
              zIndex: 1200 // Set this value lower than the spinner's z-index
            }
          }}
          value={customerName}
          //onChange={handleChange}
          size="small"
          input={<OutlinedInput label="MultiSelect" />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }} MenuProps>
                  <div>
                    {customerName.length === 1 &&(
                    <span>{customerName[0]?.substring(0, 12)}</span>
                    )}
                    {customerName.length > 1 && (
                      <span>{customerName[0]?.substring(0, 12)}  + <b>{displayItem}</b></span>
                    )}
                    <span>
                      <CancelIcon
                        sx={{
                          paddingLeft: "25px",
                          top: "20%",
                          position: "absolute",
                        }}
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                        onClick={(e) => handleDelete(e)}
                      />
                    </span>
                  </div>
            </Box>
          )}
        >
          <MenuItem onClick={handleSelectAll}>
            <Checkbox checked={selectAll} />
            <ListItemText primary="Select All" />
          </MenuItem>
          <ListSubheader>
            <TextField
              size="small"
              inputRef={textInput}
              placeholder=""
              //fullWidth
              value={searchText}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  /*close icon to clear the search text*/
                  <InputAdornment position="end">
                    <IconButton onClick={() => setSearchText("")}>
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => handleInputChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {namesData.slice(0, 100)?.map((name, index) => (
            <MenuItem key={index + name} value={name}>
              {selectAll ? <Checkbox  onChange={(e) => handleChange(e, name)}
                checked={customerName.some((o) => o === name)}
              /> :
                <Checkbox onChange={(e) => handleChange(e, name)} checked={customerName.indexOf(name) > -1} />}
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      </InfiniteScroll>
    </div>
    
  )
}
 
export default MultiSelectCustomers